import { getNumberFromString } from '../../../utility/formatNumbers';
import { isValue } from '../../../utility/isValue';

export const getFormikInitialValues = (schema, data) => {
  return schema.reduce((obj, field) => {
    const dataItem = data[field.name];
    if (isValue(dataItem)) {
      return { ...obj, [field.name]: dataItem };
    } else if (field.defaultItems && Array.isArray(field.defaultItems)) {
      return { ...obj, [field.name]: field.defaultItems };
    } else if (field.defaultValue) {
      return { ...obj, [field.name]: field.defaultValue };
    } else {
      return { ...obj, [field.name]: '' };
    }
  }, {});
};

export const getFormikInitialTableValues = (schema, dataArray) => {
  if (Array.isArray(dataArray)) {
    return dataArray.reduce((obj, dataItem, index) => {
      const dataItemFields = schema.reduce(
        (itemObj, field) => ({
          ...itemObj,
          [`${field.name}_${index}`]: dataItem[field.name],
        }),
        {}
      );

      return {
        ...obj,
        ...dataItemFields,
      };
    }, {});
  } else {
    return {};
  }
};

export const trimValues = (obj) => {
  const tempObj = { ...obj };
  Object.keys(tempObj).forEach((key) => {
    if (typeof tempObj[key] === 'string') {
      tempObj[key] = tempObj[key].trim();
    }
  });
  return tempObj;
};

export const cleanData = (data) => {
  const cleaned = {};

  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === 'string') {
      let formattedValue = value.trim();

      if (formattedValue === '') {
        formattedValue = null;
      }

      if (/^[0-9,.]+$/g.test(formattedValue)) {
        formattedValue = getNumberFromString(formattedValue);
      }

      cleaned[key] = formattedValue;
    } else if (typeof value === 'object') {
      cleaned[key] = value;
    } else if (value !== undefined) {
      cleaned[key] = value;
    }
  });
  return cleaned;
};
